module.exports = __webpack_public_path__ + "static/icon_mobile-4a3fdac4c7e69a6def58cccec3c0513e.jpg";